// extracted by mini-css-extract-plugin
export var completionBody = "_ex-2";
export var completionCard = "_ex-0";
export var completionFooter = "_ex-3";
export var completionTitle = "_ex-1";